import React from 'react';
import { Row } from 'antd';
import { RouteComponentProps } from 'react-router';
import { FranchiseeCenterLayout } from 'common/components/Layouts/FranchiseeCenterLayout';
import { FranchiseeStatistics } from 'entities/Statistic/components/FranchiseeStatistics';

type AllProps = RouteComponentProps;

export const StatisticFranchiseePage: React.FC<AllProps> = () => {
  return (
    <FranchiseeCenterLayout>
      <Row justify="center" align="middle">
        <span className="franchisee__text_title" title="Statistics">
          Statistics
        </span>
      </Row>

      <FranchiseeStatistics />
    </FranchiseeCenterLayout>
  );
};
